export default {
    base: {},
    domains: {},
    authorityUrl: {},
    miniPrograms: {},
    wxPages: [],
    wxCategoryList: []
}
